import React from "react";
import {connect} from "react-redux";
import {withRouter} from "react-router";
import PropTypes from "prop-types";
import CRUDLayout, {CRUDMapStateToPropsPropTypes, CRUDMapDispatchToProps, CRUDMapDispatchToPropsPropTypes, CRUDMapStateToProps} from "CRUDLayout";
import TableWithModalsMixin from "../../components/TableWithModalsMixin";
import DonorModal from "./DonorModal";
import columnsGenerator from "./tableColumns";
import donorActions from "../../actions/donors";

export class DonorListComponent extends TableWithModalsMixin {
    render = () => (
      <CRUDLayout
        {...this.props}
        title='Donors'
        entityName='Donor'
        columnsGenerator={columnsGenerator}
        addModalComponent={DonorModal}
        getItem={this.getItem}
        handleDragEnd={this.handleDragEnd}
        onSave={this.saveItem}
      />
    );
}

DonorListComponent.propTypes = {
    ...CRUDMapStateToPropsPropTypes,
    ...CRUDMapDispatchToPropsPropTypes,
    data: PropTypes.arrayOf(
      PropTypes.shape({
          id: PropTypes.number,
          name: PropTypes.string,
          code: PropTypes.string,
          isDeprecated: PropTypes.bool
      })
    ).isRequired,
    selectedItem: PropTypes.shape({
        id: PropTypes.number,
        name: PropTypes.string,
        code: PropTypes.string,
        isDeprecated: PropTypes.bool
    }),
    formValues: PropTypes.shape({}),
};

export const mapStateToProps = state => (
  CRUDMapStateToProps(state, 'donors', 'exercise.add_donor', 'exercise.change_donor')
)

export const mapDispatchToProps = dispatch => (
  CRUDMapDispatchToProps(dispatch, donorActions, 'donors')
);

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(DonorListComponent)
);
